require('../styles/tlmd-index.styl');

//import  * as observation    from './tlmd/observation/inspection-handlers';
// TEMP DISABLED (LAPTOP node version too low)export * as glm from 'gl-matrix'
export { initialize, authenticate } from './tlmd/application/init';
export { createMapBoundsObservable } from './tlmd/map/map';
export { createTimeRangeObservable, createAnimationScriptObservable, 
createHeightObservable, createTimeCursorObservable, 
createAnimationObservable, createControlsObservable } from './tlmd/timeline/timeline';

//export { ContainerDefinition } from './tlmd/panel/cabinets';
export { InspectionPanel, ContainerPanel } from './tlmd/panel/panel';

export { domReady, DragUtil, eventOptionsSupported, eventObserver, eventPatternObserver, delegatedObserver } from './tlmd/dom/dom';
export { testForm } from './tlmd/forms/form-dev';
export { initHello } from './tlmd/component/test'
export { initHello2 } from './tlmd/component/test'
export { Hysplit, HysplitOptions } from './tlmd/hysplit/hysplit';
export { HysplitViewer } from './tlmd/hysplit/hysplit-viewer';

//export { observation };

//export  { SpeechBubbleOrientation, elemSpeechBubble, elemEditorBubble }   from './tlmd/observation/speech';

//export { ScalarFieldSourceCache } from './tlmd/scalar-field/data';

/** for research START */
export { XYZFile } from './tlmd/scalar-field/xyz-source';
export { ScalarField } from './tlmd/scalar-field/scalar-field';
export { ScalarFieldSequence, ScalarFieldSequenceImpl } from './tlmd/scalar-field/scalar-field-seq';
export { Isoline } from './tlmd/scalar-field/isoline';
export { constraintColorInterpolator, colorToString } from './tlmd/util/color';
/** for research END */


// arc/sphere of influence
export { AoiPainter } from './tlmd/observation/observations-aoi-visualizer';
//export { LatLng, Point2D } from './tlmd/map/map-types';
//export { Line } from './tlmd/svg/line';
//export { Path } from './tlmd/svg/path';
//export { Triangulator } from './tlmd/geometry/triangulator';
//interpolation research
//export { NearestNeighbourInterpolator, LinearInterpolator, CubicInterpolator } from './tlmd/util/util';


export { ScalarFieldManager } from './tlmd/worker/scalar-field-manager';
export { MapOverlaySVGContentProducer } from './tlmd/map/svg-overlay';

export { xhr, xhrPromise } from './tlmd/xhr/xhr';
export { SHA256Digester, encrypt } from './tlmd/application/security';
export { localStorage } from './tlmd/storage/local-storage';
export { localize } from './tlmd/application/i18n';

export { OverlayType } from './tlmd/timeline/timeline';
export { TimelineOverlay } from './tlmd/timeline/timeline-overlay';
export { createElemSelector as createElemId } from './tlmd/data/item';
export { TimelineControls, setupTimeline } from './tlmd/timeline/timeline-controls';

export { hasFullscreen, requestFullscreen, exitFullscreen } from './tlmd/dom/dom'


export { Polygon } from './tlmd/geometry/polygon';
export { SetBuilder  } from './tlmd/geometry/sets';

export { MapOverlay } from './tlmd/map/map-overlay';

/** Multi Threading Research START */
export { RenderManager } from './tlmd/worker/render-manager';
/** Multi Threading Research END */


/** for debugging */
export {  isLeapYear, getDaysInYear, getDaysInMonth, getDayOfTheYear, getWeekCount, getWeek, getWeekStart  } from './tlmd//util/util';

/* controls */
export { WeekControl } from './tlmd/controls/week-control';
/* components */
export { Legend } from './tlmd/component/legend';
export { Swatches } from './tlmd/component/swatches';
export * as d3 from 'd3';
export { wrapTLMDInterpolator, colorInterpolator, colorScheme  } from './tlmd/d3/color-interpolator';
export { getColorScheme, modifyDomain, normalizeColorInterpolator, getDefaultColorInterpolator, getCustomColorInterpolator, extractMonoHueInterpolator } from './tlmd/util/color';

import  {TlmdDomainCaption, ObservationReport, SensorReport, ModellingReport, MfaSelector }   from '@mapp/r-mapp-lib';
export {TlmdDomainCaption, ObservationReport, SensorReport, ModellingReport, MfaSelector } ;
